import { useQuery } from 'react-query';
import { User } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export default function useGetStrapiUser(userId?: number) {
  return useQuery<User>(
    ['userData', userId],
    async () => await restFactory.get<User>(`/dj/api/v1/strapi_user/${userId}`),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: Number.isFinite(userId),
    }
  );
}
